// update along with app/lib/enums/supercharged_status.py
const SuperchargedStatus = {
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
  COMPLETED: 'COMPLETED',
  ERROR_IN_REQUEST: 'ERROR_IN_REQUEST',
  ERROR_IN_TOKEN_GENERATION: 'ERROR_IN_TOKEN_GENERATION',
};

const SuperchargedStatusLabels = {
  PENDING: 'Pending',
  PROCESSING: 'Processing',
  COMPLETED: 'Completed',
  ERROR_IN_REQUEST: 'Error In Request',
  ERROR_IN_TOKEN_GENERATION: 'Error In Token Generation',
};

export { SuperchargedStatus, SuperchargedStatusLabels };
